import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://efektivos.com';
const DEFAULT_IMAGE = `${BASE_URL}/assets/efektivos_og.png`;

// Keywords principales para SEO
const PRIMARY_KEYWORDS = [
  'préstamos Guatemala',
  'créditos Guatemala',
  'préstamos personales Guatemala',
  'préstamos rápidos Guatemala',
  'créditos rápidos',
  'préstamos en línea Guatemala',
  'préstamos inmediatos',
  'Efektivos',
  'app de préstamos Guatemala',
  'financiera Guatemala'
].join(', ');

export const SEO = ({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  noindex = false,
  structuredData = null,
  keywords = PRIMARY_KEYWORDS,
}) => {
  const canonicalUrl = `${BASE_URL}${path}`;

  const fullTitle = title
    ? `${title} | Efektivos Guatemala`
    : 'Efektivos | Préstamos y Créditos Rápidos en Guatemala';

  const defaultDescription = description ||
    'Solicita préstamos rápidos en Guatemala con Efektivos. Créditos personales con requisitos mínimos, aprobación inmediata y desembolso el mismo día. Descarga la app.';

  return (
    <Helmet>
      {/* Titulo y Description */}
      <title>{fullTitle}</title>
      <meta name="description" content={defaultDescription} />

      {/* Keywords - importante para SEO local */}
      <meta name="keywords" content={keywords} />

      {/* Idioma y region */}
      <html lang="es-GT" />
      <meta httpEquiv="content-language" content="es-GT" />

      {/* Geo Tags - SEO Local Guatemala */}
      <meta name="geo.region" content="GT" />
      <meta name="geo.placename" content="Guatemala" />
      <meta name="geo.position" content="14.634915;-90.506882" />
      <meta name="ICBM" content="14.634915, -90.506882" />

      {/* Canonical y hreflang */}
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="es-GT" href={canonicalUrl} />
      <link rel="alternate" hrefLang="es" href={canonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />

      {/* Open Graph - optimizado */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={defaultDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="es_GT" />
      <meta property="og:site_name" content="Efektivos Guatemala" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={defaultDescription} />
      <meta name="twitter:image" content={image} />

      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};
